module.exports = __webpack_public_path__ + "img/icon-down.642c9de6.svg";